(() => {
  function init(root) {
    if (root.dataset.articleReady) return;
    root.dataset.articleReady = 'true';
    const back = root.querySelector('[data-article-back]');
    back?.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !document.referrer) return;
      const previous = new URL(document.referrer);
      if (previous.origin === location.origin && history.length > 1) {
        event.preventDefault();
        history.back();
      }
    });
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-article-more]');
      if (!link || !root.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.getAttribute('aria-disabled') === 'true') return;
      const cards = root.querySelector('[data-article-cards]');
      const pagination = root.querySelector('[data-article-pagination]');
      const status = root.querySelector('[data-article-status]');
      link.setAttribute('aria-disabled', 'true');
      cards.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const url = new URL(link.href);
        url.hash = '';
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Article request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-nom-article]');
        const nextCards = incoming?.querySelectorAll('[data-article-card]');
        const nextPagination = incoming?.querySelector('[data-article-pagination]');
        if (!nextCards?.length || !nextPagination) throw new Error('Article response incomplete');
        const existing = new Set([...cards.querySelectorAll('h3 a')].map(item => item.getAttribute('href')));
        let firstNew;
        for (const card of nextCards) {
          const destination = card.querySelector('h3 a')?.getAttribute('href');
          if (destination && !existing.has(destination)) {
            const added = document.importNode(card, true);
            firstNew ||= added.querySelector('a');
            cards.append(added);
            existing.add(destination);
          }
        }
        if (!firstNew) throw new Error('Article response did not advance');
        pagination.replaceChildren(...[...nextPagination.childNodes].map(node => document.importNode(node, true)));
        status.textContent = status.dataset.loaded;
        firstNew?.focus({ preventScroll: true });
      } catch {
        status.textContent = status.dataset.error;
        link.removeAttribute('data-article-more');
        link.removeAttribute('aria-disabled');
      } finally {
        cards.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-nom-article]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nom-article]').forEach(init));
})();
